var Backbone, FAQMainView, FaqMainpageTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FaqMainpageTemplate = require('../../mainpage.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

FAQMainView = (function(superClass) {
  extend(FAQMainView, superClass);

  function FAQMainView() {
    return FAQMainView.__super__.constructor.apply(this, arguments);
  }

  FAQMainView.VIEWID = 0;

  FAQMainView.VIEWNAME = "home";

  FAQMainView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.faq';
    this.template = FaqMainpageTemplate;
    this.breadCrumbView = this.options.breadCrumbView;
    this.container = this.options.container;
    this.homeModel = this.options.homeModel;
    this.errorView = this.options.errorView;
    this.spinner = this.options.spinner;
    return this.errorContainer = this.options.errorContainer;
  };

  FAQMainView.prototype.events = function() {
    return {
      'click .topic-header': 'toggleArticleSection'
    };
  };

  FAQMainView.prototype.render = function() {
    var data;
    data = this.getFAQMainData();
    if (data != null) {
      return this.constructFaqHomePage(data);
    } else {
      this.container.empty();
      this.spinner.show();
      this.homeModel.fetch({
        success: (function(_this) {
          return function(model, response, options) {
            stopTimer("t_fh");
            _this.spinner.hide();
            return _this.constructFaqHomePage(response);
          };
        })(this),
        error: (function(_this) {
          return function(model, xhr, options) {
            stopTimer("t_fh");
            _this.spinner.hide();
            return _this.renderErrorPage();
          };
        })(this)
      });
      return startTimer("t_fh");
    }
  };

  FAQMainView.prototype.toggleArticleSection = function(event) {
    var $target, id;
    $target = $(event.target).closest('.topic-header');
    id = $target.find('.topic-heading').attr('topicId');
    return this.toggleArticleList(id);
  };

  FAQMainView.prototype.getFAQMainData = function() {
    var data;
    data = this.homeModel.attributes;
    if ((data != null ? data.faqMain : void 0) != null) {
      return data;
    } else {
      return null;
    }
  };

  FAQMainView.prototype.constructFaqHomePage = function(response) {
    if ((response != null ? response.faqMain : void 0) != null) {
      this.toHtml(response);
      return this.scrollToTopic(this.options.topic);
    } else {
      return this.renderErrorPage();
    }
  };

  FAQMainView.prototype.renderErrorPage = function() {
    return this.errorView.render({
      container: this.container
    });
  };

  FAQMainView.prototype.toHtml = function(response) {
    this.$el.html(toHtml(this.template, this.toHash(response), this.I18nScope));
    this.breadCrumbView.render();
    return this.container.html(this.el);
  };

  FAQMainView.prototype.toggleArticleList = function(topic) {
    var $container;
    $("#" + topic).toggle();
    $container = $("#" + topic).closest('.faq-topic');
    $container.find('.icon-arrow-right').toggle();
    $container.find('.icon-arrow-down').toggle();
    return scrollTo($container);
  };

  FAQMainView.prototype.scrollToTopic = function(topic) {
    if (topic) {
      return this.toggleArticleList(topic);
    }
  };

  FAQMainView.prototype.toHash = function(response) {
    var columnSize, extra, faqMain, hash, help_topics_column1, help_topics_column2, help_topics_column3, index, ref, ref1;
    hash = {
      hasTrendingQuestions: false,
      hasHelpTopics: false,
      hasTopicArticleMappings: false
    };
    if ((response != null ? response.faqMain : void 0) != null) {
      faqMain = response.faqMain;
      if (evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showVerticalPageFlow : void 0)) {
        hash.hasTopicArticleMappings = ((ref = faqMain.topic_article_mappings) != null ? ref.length : void 0) > 0 ? true : false;
        hash.topicArticleMappings = faqMain.topic_article_mappings;
      } else {
        help_topics_column1 = [];
        help_topics_column2 = [];
        help_topics_column3 = [];
        hash.hasTrendingQuestions = ((ref1 = faqMain.trending_question) != null ? ref1.length : void 0) > 0 ? true : false;
        if ((faqMain.help_topics != null) && faqMain.help_topics.length > 0) {
          _.each(faqMain.help_topics, function(helpTopic) {
            if (helpTopic.text != null) {
              return helpTopic.text = helpTopic.text.replace(/(<([^>]+)>)/ig, "");
            }
          });
          hash.hasHelpTopics = true;
          columnSize = Math.floor(faqMain.help_topics.length / 3);
          extra = faqMain.help_topics.length % 3;
          if (columnSize > 0) {
            help_topics_column1 = faqMain.help_topics.slice(0, columnSize);
            help_topics_column2 = faqMain.help_topics.slice(columnSize, 2 * columnSize);
            help_topics_column3 = faqMain.help_topics.slice(2 * columnSize, 3 * columnSize);
          }
          if (extra > 0) {
            index = 3 * columnSize;
            while (extra > 0) {
              help_topics_column1.push(faqMain.help_topics[index++]);
              extra--;
              if (extra > 0) {
                help_topics_column2.push(faqMain.help_topics[index++]);
              }
              extra--;
            }
          }
        }
        if (hash.hasTrendingQuestions) {
          _.each(faqMain.trending_question, function(trendingQn) {
            if (trendingQn.text != null) {
              return trendingQn.text = trendingQn.text.replace(/(<([^>]+)>)/ig, "");
            } else if (trendingQn.heading != null) {
              return trendingQn.heading = trendingQn.heading.replace(/(<([^>]+)>)/ig, "");
            }
          });
        }
        hash.trending_question = faqMain.trending_question;
        hash.help_topics_column1 = help_topics_column1;
        hash.help_topics_column2 = help_topics_column2;
        hash.help_topics_column3 = help_topics_column3;
      }
    }
    return hash;
  };

  return FAQMainView;

})(Backbone.View);

module.exports = FAQMainView;

//# sourceMappingURL=data:application/json;base64,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
